






























import { Component, Mixins, Vue, Ref } from 'vue-property-decorator'
import InputSimple from '@/components/common/atoms/InputSimple.vue'
import SelectBase, { SelectOption } from '@/components/common/atoms/SelectBase.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import LinkArea from '@/components/academy/organisms/LinkArea.vue'
import StudyTable from '@/components/academy/organisms/StudyTable.vue'
import StudyListApis, { StudyData, StudySearchQuery, SettingData } from '@/mixins/requests/academy/StudyListApis.vue'
import CookieMethods from '@/mixins/CookieMethods.vue'
import PaginationButton from '@/components/common/organisms/PaginationButton.vue'

@Component({
  components: {
    InputSimple,
    SelectBase,
    ButtonBase,
    StudyTable,
    LinkArea,
    PaginationButton,
  },
})
export default class StudyList extends Mixins(StudyListApis, CookieMethods) {
  private studyContentId = ''
  private gradeId: number | null = null
  private studyName = ''
  private currentQuery: StudySearchQuery = {}

  private studyList: StudyData[] = []
  private gradeOptions: SelectOption[] = []

  // ref: ページネーション
  @Ref() paginationButton!: PaginationButton

  private async mounted() {
    // TODO：検索条件の復元
    Vue.prototype.$loading.start()
    try {
      this.gradeOptions = await this.loadGrades()
      await this.search()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private async onClickSearch() {
    Vue.prototype.$loading.start()
    try {
      await this.search()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private async search() {
    this.currentQuery = {}
    if (this.studyContentId) {
      this.currentQuery.studyContentId = this.studyContentId
    }
    if (this.gradeId) {
      this.currentQuery.gradeId = this.gradeId
    }
    if (this.studyName) {
      this.currentQuery.studyName = this.studyName
    }
    await this.loadStudyList()
  }

  private onClickStudentComfirmButton(studyContentId: string) {
    this.$router.push({
      name: 'AcademyStudentForStudy',
      params: { studyContentId: studyContentId },
    })
  }

  private onClickAcademySummaryButton(studyContentId: string) {
    this.$router.push({
      name: 'AcademySummaryResult',
      params: { studyContentId: studyContentId },
    })
  }

  private async onClickSave() {
    if (!confirm('保存してよろしいですか？')) return

    Vue.prototype.$loading.start()
    try {
      // 上位権限の設定は更新対象外
      const settingIsSingleData: SettingData[] = this.studyList
        .filter((study: StudyData) => !study.disableIsSingle)
        .map((study: StudyData) => {
          return { studyContentId: study.studyContentId, isSingle: study.isSingle }
        })
      const settingPeriodsData: SettingData[] = this.studyList
        .filter((study: StudyData) => !study.disablePeriods)
        .map((study: StudyData) => {
          return { studyContentId: study.studyContentId, periods: study.periods }
        })
      const settingIsTimeData: SettingData[] = this.studyList
        .filter((study: StudyData) => !study.disableIsTime)
        .map((study: StudyData) => {
          return { studyContentId: study.studyContentId, isTime: study.isTime }
        })
      const settingData: SettingData[] = settingIsSingleData.concat(settingPeriodsData).concat(settingIsTimeData)
      await this.configureStudies(settingData)
      alert('保存が完了しました。')
    } catch (e) {
      alert('保存中にエラーが発生しました。')
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private async loadStudyList() {
    const studyObject = await this.searchStudies(this.paginationButton.paginationCurrentPage, this.currentQuery)
    this.studyList = studyObject.responses
    this.paginationButton.paging(studyObject.pagination)
  }

  private async onClickPaginationButton() {
    await this.search()
  }
}
